import React, { memo, useCallback } from 'react';
import './dbStyle.css';
import { ArrowDropDown, ArrowRight, Circle } from '@mui/icons-material';
import ActionButtons from '../Buttons/ActionButtons';
import { useMediaQuery } from '@mui/material';

function VirtualTableRow({
  item,
  borderRightColor,
  currentTheme,
  handleTransactionModal,
  isExpand,
  newLedgerAccountID,
  hideAmount,
  theme,
  toggleExpandRow,
  MoneyFormatv3,
  handleSelectRow,
  Tooltip,
}) {
  const isGroup = React.useMemo(() => item?.category === 'group', [item?.category]);
  const isLedger = React.useMemo(() => item?.category === 'ledger', [item?.category]);
  const isRestricted = React.useMemo(() => item?.restrictedflag === 1, [item?.restrictedflag]);
  const isNewLedger = React.useMemo(
    () => newLedgerAccountID === (isLedger ? item?._id : item?.id),
    [newLedgerAccountID, isLedger, item?._id, item?.id]
  );

  const itemColor = React.useMemo(
    () => (isGroup ? theme.palette.primary.main : currentTheme === 'black' ? '#fff' : '#000'),
    [isGroup, theme.palette.primary.main, currentTheme]
  );

  const handletoggleExpandRow = useCallback(() => {
    isGroup && toggleExpandRow(item.id, item.type);
  }, [item.id, item.type, isGroup, toggleExpandRow]);

  const handleTSMODAL = useCallback(() => {
    handleTransactionModal(item?.category, item.id);
  }, [handleTransactionModal, item.category, item.id]);

  // const isDebit =
  //   (item.balancesign === -1 && item.balance >= 0) ||
  //   (item.balancesign === 1 && item.balance < 0);

  const isDebit = item.balancesign === -1;

  // const debitAmount = isDebit ? Math.abs(item.balance) : 0;
  // const creditAmount = !isDebit ? Math.abs(item.balance) : 0;

  const debitAmount = isDebit ? item.balance : 0;
  const creditAmount = !isDebit ? item.balance : 0;

  const moneyFormat = useCallback(
    (value) => {
      return MoneyFormatv3(value);
    },
    [MoneyFormatv3]
  );

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  let multiplyBy = isSmallScreen ? 5 : 10;
  const level = item?.depth * multiplyBy;

  return (
    <div className="table-row">
      <div className="table-cell-1" style={{ borderRight: `4px solid ${borderRightColor}` }}>
        <div className="table-cell-1-inner" style={{ paddingLeft: `${level}px` }}>
          <button className="table-icon" onClick={handletoggleExpandRow}>
            {isGroup ? (
              isExpand ? (
                <svg xmlns="http://www.w3.org/2000/svg" width="12.033" height="6" viewBox="0 0 10.033 5">
                  <polygon points="5.016 0 0 0.003 2.506 2.5 5.016 5 7.525 2.5 10.033 0.003 5.016 0" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12.033" viewBox="0 0 5 10.033">
                  <polygon points="0 5.016 0.003 10.033 2.5 7.525 5 5.016 2.5 2.506 0.003 0 0 5.016" />
                </svg>
              )
            ) : (
              <div className="circle-icon"></div>
            )}
          </button>
          <p
            onClick={isLedger ? handleTSMODAL : undefined}
            className="table-text"
            style={{
              color: itemColor,
              fontWeight: isGroup ? 'bold' : 'normal',
              fontSize: '13px',
              cursor: isLedger ? 'pointer' : 'default',
            }}
          >
            {item?.name}
            <span className="custom-tooltip" style={{ left: `${item?.depth * 10}px` }}>
              {item?.name}
            </span>
          </p>

          {isRestricted && <p className=" hover-default">{isLedger ? 'Default A/C' : 'Default Group'}</p>}
          {isNewLedger && <div className="new-label-box">New</div>}
        </div>
        <ActionButtons item={item} handleSelectRow={handleSelectRow} theme={theme} bgcolor={theme.palette.primary.main} />
      </div>

      <div className="table-cell-2">
        <div className="table-cell-2-inner" style={{ borderRight: `4px solid ${borderRightColor}` }}>
          {(!hideAmount || isLedger) && (
            <p
              className="table-text-2"
              style={{
                '--item-color': itemColor,
                fontWeight: isGroup ? 'bold' : 'normal',
                fontSize: '13px',
              }}
            >
              ₹ {moneyFormat(debitAmount)}
            </p>
          )}
        </div>
      </div>
      <div className="table-cell-3">
        {(!hideAmount || isLedger) && (
          <p
            className="table-text-2"
            style={{
              '--item-color': itemColor,
              fontWeight: isGroup ? 'bold' : 'normal',
              textAlign: 'right',
              fontSize: '13px',
            }}
          >
            ₹ {moneyFormat(creditAmount)}
          </p>
        )}
      </div>
    </div>
  );
}
export default memo(VirtualTableRow);
